/* jshint esversion: 6 */
import React from 'react';
import InputBehaviorComponent from 'app/components/EditorComponents/InputBehaviorComponent.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';


class CreateSubtypePanel extends React.Component {
    constructor(props) {
        super(props);

        this.subtypeUsernameHandler = this.subtypeUsernameHandler.bind(this);

    }

    subtypeUsernameHandler(e) {
        let nameEvent = {
                currentTarget: {
                    dataset: {
                        field: this.props.statePath + '.name'
                    }
                },
                target: {
                    value: e.target.value
                }
            };

        this.props.changeHandler(e);
        this.props.changeHandler(nameEvent);
    }

    render() {
        let behavior = null,
            constants = this.props.app.config.constants,
            fields = null,
            subtypeUsername = 'username',
            subtypeUsernameError = null,
            urlError = null,
            subtypeBoardError = null,
            subtypeCompanyNameError = null,
            subtypeSearchError = null,
            nameError = null,
            errorKeys = ['CURATION_INPUT_CREATE', 'INPUT_UPDATE', 'INPUT_CREATE', 'INPUT_VALIDATE'];

        if (this.props.input === null) {
            return null;
        }

        if (this.props.input.subtypeUsername !== undefined) {
            subtypeUsername = this.props.input.subtypeUsername;
        }

        subtypeUsernameError = (
            <ErrorModule
                app={this.props.app}
                keys={errorKeys}
                render={(state) => {
                    return (
                        <FieldError field="subtypeUsername" errors={state.errors}/>
                    );
                }}/>
        );

        nameError = (
            <ErrorModule
                app={this.props.app}
                keys={errorKeys}
                render={(state) => {
                    return (
                        <FieldError field="name" errors={state.errors}/>
                    );
                }}/>
        );

        urlError = (
            <ErrorModule
                app={this.props.app}
                keys={errorKeys}
                render={(state) => {
                    return (
                        <FieldError field="url" errors={state.errors}/>
                    );
                }}/>
        );

        subtypeCompanyNameError = (
            <ErrorModule
                app={this.props.app}
                keys={errorKeys}
                render={(state) => {
                    return (
                        <FieldError field="subtypeCompanyName" errors={state.errors}/>
                    );
                }}/>
        );

        subtypeSearchError = (
            <ErrorModule
                app={this.props.app}
                keys={errorKeys}
                render={(state) => {
                    return (
                        <FieldError field="subtypeCompanyName" errors={state.errors}/>
                    );
                }}/>
        );

        switch (parseInt(this.props.input.subtype)) {
            case constants.INPUT_SUBTYPE_PINTEREST:
                fields = (
                    <div>
                        <div className="section-header">
							Auto share Pinterest Pins
						</div>
                        <fieldset>
                            <legend>Pinterest User <HelpButton which="pinterestFeed"/><span className="required">*</span></legend>
                            {nameError}
                            {subtypeUsernameError}
                            {urlError}
                            {"https://www.pinterest.com/"}<input type="text"
                                className="text-input small"
                                placeholder="username"
                                defaultValue={this.props.input.subtypeUsername}
                                onChange={this.subtypeUsernameHandler}
                                data-field={this.props.statePath + ".subtypeUsername"} />
                        </fieldset>
                        <fieldset>
                            <legend>Pinterest Board (optional)</legend>
                            <ErrorModule
                                app={this.props.app}
                                keys={['CURATION_INPUT_CREATE', 'INPUT_UPDATE', 'INPUT_CREATE', 'INPUT_VALIDATE']}
                                render={(state) => {
                                    return (
                                        <FieldError field="subtypeBoard" errors={state.errors}/>
                                    );
                                }}/>
                            {"https://www.pinterest.com/" + subtypeUsername + "/"}<input type="text"
                                className="text-input small"
                                placeholder="boardname"
                                defaultValue={this.props.input.subtypeBoard}
                                onChange={this.props.changeHandler}
                                data-field={this.props.statePath + ".subtypeBoard"} />
                        </fieldset>
                    </div>
                );
                break;

            case constants.INPUT_SUBTYPE_YOUTUBE:
                fields = (
                    <div>
                        <div className="section-header">
							Auto post videos from YouTube
						</div>
                        <fieldset>
                            <legend>YouTube Video or Channel<span className="required">*</span></legend>
                            {nameError}
                            {urlError}
                            <input type="text"
                                className="text-input medium flush"
                                placeholder="https://www.youtube.com/user/channel"
                                defaultValue={this.props.input.url}
                                onChange={this.subtypeUsernameHandler}
                                data-field={this.props.statePath + ".url"} />
                        </fieldset>
                    </div>
                );
                break;

            case constants.INPUT_SUBTYPE_VIMEO:
                fields = (
                    <div>
                        <div className="section-header">
							Auto post videos from Vimeo
						</div>
                        <fieldset>
                            <legend>Vimeo Channel<span className="required">*</span></legend>
                            {nameError}
                            {subtypeUsernameError}
                            {urlError}
                            {"https://vimeo.com/channels/"}<input type="text"
                                className="text-input medium"
                                placeholder="channelname"
                                defaultValue={this.props.input.subtypeUsername}
                                onChange={this.subtypeUsernameHandler}
                                data-field={this.props.statePath + ".subtypeUsername"} />
                        </fieldset>
                    </div>
                );
                break;

            case constants.INPUT_SUBTYPE_EBAY:
                fields = (
                    <div>
                        <div className="section-header">
							Auto share eBay listings
						</div>
                        <fieldset>
                            <legend>eBay Search Term<span className="required">*</span></legend>
                            {nameError}
                            {subtypeSearchError}
                            {urlError}
                            <input type="text"
                                className="text-input medium flush"
                                placeholder="Product search term"
                                defaultValue={this.props.input.subtypeSearch}
                                onChange={this.subtypeUsernameHandler}
                                data-field={this.props.statePath + ".subtypeSearch"} />
                        </fieldset>
                        <fieldset>
                            <legend>eBay Seller Id (optional)</legend>
                            {nameError}
                            {subtypeUsernameError}
                            {urlError}
                            <input type="text"
                                className="text-input small flush"
                                placeholder="SellerId or Username"
                                defaultValue={this.props.input.subtypeUsername}
                                onChange={this.subtypeUsernameHandler}
                                data-field={this.props.statePath + ".subtypeUsername"} />
                        </fieldset>
                    </div>
                );
                break;

            case constants.INPUT_SUBTYPE_ETSY:
                // <fieldset>
                //     <legend>Etsy Username</legend>
                //     {nameError}
                //     {subtypeUsernameError}
                //     {urlError}
                //     {"https://www.etsy.com/people/"}<input type="text"
                //         className="text-input med"
                //         placeholder="Username"
                //         defaultValue={this.props.input.subtypeUsername}
                //         onChange={this.subtypeUsernameHandler}
                //         data-field={this.props.statePath + ".subtypeUsername"} />{"/favorites/items.rss"}
                // </fieldset>
                fields = (
                    <div>
                        <div className="section-header">
							Auto post items from an Etsy shop
						</div>
                        <fieldset>
                            <legend>Etsy Shop Name</legend>
                            {nameError}
                            {subtypeCompanyNameError}
                            {urlError}
                            {"https://www.etsy.com/shop/"}<input type="text"
                                className="text-input medium"
                                placeholder="shopname"
                                defaultValue={this.props.input.subtypeCompanyName}
                                onChange={this.subtypeUsernameHandler}
                                data-field={this.props.statePath + ".subtypeCompanyName"} />
                        </fieldset>
                    </div>
                );
                break;

            case constants.INPUT_SUBTYPE_SHOPIFY:
                fields = (
                    <div>
                        <div className="section-header">
							Auto post items from a Shopify store
						</div>
                        <fieldset>
                            <legend>Shopify Store <span className="required">*</span></legend>
                            {nameError}
                            {subtypeUsernameError}
                            {urlError}
                            {"https://"}<input type="text"
                                className="text-input small"
                                placeholder="yourstore.com"
                                defaultValue={this.props.input.subtypeUsername}
                                onChange={this.subtypeUsernameHandler}
                                data-field={this.props.statePath + ".subtypeUsername"} />
                        </fieldset>
                        <fieldset>
                            <legend>Shopify Collection (optional)</legend>
                            <ErrorModule
                                app={this.props.app}
                                keys={['CURATION_INPUT_CREATE', 'INPUT_UPDATE', 'INPUT_CREATE', 'INPUT_VALIDATE']}
                                render={(state) => {
                                    return (
                                        <FieldError field="subtypeBoard" errors={state.errors}/>
                                    );
                                }}/>
                            {"https://" + subtypeUsername + "/collections/"}<input type="text"
                                className="text-input small"
                                placeholder="collectionname"
                                defaultValue={this.props.input.subtypeBoard}
                                onChange={this.props.changeHandler}
                                data-field={this.props.statePath + ".subtypeBoard"} />
                        </fieldset>
                    </div>
                );
                break;

            case constants.INPUT_SUBTYPE_SUBSTACK:
                fields = (
                    <div>
                        <div className="section-header">
							Auto post items from a Substack
						</div>
                        <fieldset>
                            <legend>Substack URL <span className="required">*</span></legend>
                            {nameError}
                            {subtypeUsernameError}
                            {urlError}
                            {"https://"}<input type="text"
                                className="text-input small"
                                placeholder="your Substack URL"
                                defaultValue={this.props.input.subtypeUsername}
                                onChange={this.subtypeUsernameHandler}
                                               data-field={this.props.statePath + ".subtypeUsername"} />
                        </fieldset>
                    </div>
                );
                break;

        }

        return (
            <div className="editor-panel subtype">
                {fields}
            </div>
        );
    }
}

CreateSubtypePanel.displayName = "CreateSubtypePanel";

export default CreateSubtypePanel;
